import { TextField, Typography, useMediaQuery, useTheme } from "@mui/material";
import { Box } from "@mui/material";
import { CustomBioContainer } from "../../pages/ProfilePage/styles";
import { CustomTextField } from "../../pages/ProfilePage/styles";
import { CustomLeftTitle } from "../../pages/ProfilePage/styles";
import { FirstNameContainer } from "../../pages/ProfilePage/styles";
import { SelectField } from "../../pages/ProfileSettings/styles";
import { formatFileSize } from "../../services/trackService";
import { SkillsArray } from "../constants";
import { preferencesStageStyles } from "../InitialSettingsComponents/styles";
import { useStyles } from "../InitialSettingsComponents/styles";
import { APP_COLOR } from "../../theme";
import CheckIcon from "@mui/icons-material/Check";
import { useAuth0 } from "@auth0/auth0-react";
import { UserProfileFormProps } from "../../pages/ProfilePage/types";

export const UserProfileForm: React.FC<UserProfileFormProps> = ({
  handleChange,
  profile,
  usedStorage,
  skillList,
  setSkillList,
}) => {
  const theme = useTheme();
  const isSmallOrLarger = useMediaQuery(theme.breakpoints.up("sm"));
  const classes = useStyles();
  const { user } = useAuth0();

  const handleChangeSkill = (
    _event: React.SyntheticEvent<Element, Event>,
    value: unknown
  ) => {
    const tempSkillsArr: string[] = [];
    const values = value as Array<string>;
    const length = values.length;
    for (let i = 0; i < length; i++) {
      const tag_curr = values[i];
      tempSkillsArr.push(tag_curr);
    }
    setSkillList(tempSkillsArr);
  };

  return (
    <>
      <FirstNameContainer>
        <CustomLeftTitle>First Name</CustomLeftTitle>
        <CustomTextField
          name="firstName"
          onChange={handleChange}
          id="outlined-basic"
          value={profile.firstName}
          variant="outlined"
        />
      </FirstNameContainer>
      <FirstNameContainer>
        <CustomLeftTitle>Last Name</CustomLeftTitle>
        <CustomTextField
          name="lastName"
          onChange={handleChange}
          id="outlined-basic"
          value={profile.lastName}
          variant="outlined"
        />
      </FirstNameContainer>
      <FirstNameContainer>
        <CustomLeftTitle>User Name / Stage Name</CustomLeftTitle>
        <CustomTextField
          id="outlined-basic"
          value={profile.username}
          sx={{ backgroundColor: "#101A32" }}
          disabled
          variant="outlined"
        />
      </FirstNameContainer>
      <FirstNameContainer>
        <CustomLeftTitle>Email</CustomLeftTitle>
        <CustomTextField
          id="outlined-basic"
          value={user?.email}
          disabled
          sx={{ backgroundColor: "#101A32" }}
          variant="outlined"
        />
      </FirstNameContainer>
      <FirstNameContainer>
        <Box sx={{ minWidth: "40%" }}>
          <Typography sx={{ minWidth: "40%" }}>Your Bio</Typography>
          <Typography>Write a short introduction.</Typography>
        </Box>
        <CustomBioContainer>
          <TextField
            value={profile.bio}
            name="bio"
            fullWidth
            multiline
            rows={5}
            onChange={handleChange}
          />
        </CustomBioContainer>
      </FirstNameContainer>
      <FirstNameContainer>
        <CustomLeftTitle>Total Storage Used</CustomLeftTitle>
        <CustomTextField
          id="outlined-basic"
          variant="outlined"
          sx={{ backgroundColor: "#101A32" }}
          value={`${formatFileSize(usedStorage)}`}
          disabled
        />
      </FirstNameContainer>

      <FirstNameContainer>
        <CustomLeftTitle>Skills</CustomLeftTitle>
        <SelectField
          sx={{ width: isSmallOrLarger ? "40%" : "100%" }}
          multiple
          id="checkboxes-tags-demo"
          options={SkillsArray}
          disableCloseOnSelect
          fullWidth
          value={skillList}
          onChange={(e, v) => handleChangeSkill(e, v)}
          renderOption={(props, option, { selected }) => (
            <li
              {...props}
              style={preferencesStageStyles.list}
              className={classes.customOption}
            >
              {option as string}
              {selected && <CheckIcon style={{ color: APP_COLOR }} />}
            </li>
          )}
          renderInput={(params) => (
            <TextField
              {...params}
              InputLabelProps={{ shrink: false }}
              classes={{ root: classes.customTextField }}
            />
          )}
        />
      </FirstNameContainer>
    </>
  );
};
